<template>
    <DocsKycForm 
        :first_name="'Имя'"
        :last_name="'Фамилия'"
        :middle_name="'Отчество'"
        :email="'Электронная почта'"
        :phone="'Телефон'"
        />
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import CameraForm from '@/components/personal/verification/camera_form.vue'
import DocsKycForm from '@/components/personal/verification/docs_kyc_form.vue'

export default {
    name: 'verification',
    data() {
        return {
            
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 1000 });
        },
        lang(value){
            return this.$t(`views.verify.${value}`)
        },
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        screen_size() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        
        userPhone: function () { return this.$store.getters.StateUserPhone },
        userPrefix: function () { return this.$store.getters.StateUserPrefix },
        userPhoneNumber() { 
            if(!this.userPhone || !this.userPrefix) return null
            return `${this.userPrefix}${this.userPhone}` 
        },
        userEmail() { return this.$store.getters.StateUserEmail },
        userName() { return this.$store.getters.StateUserName },
    },
    components: {
        CameraForm,
        DocsKycForm
    },
    beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
    }
}
</script>